<template>
    <b-container>
        <b-card
            title="My Account"
            title-tag="h2"
        >
            <ul>
                <li>
                    <router-link :to="{ name: 'activity' }">
                        Account Activity
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'manage_linked_accounts' }">
                        Linked Accounts
                    </router-link>
                </li>
                <li><a v-b-modal.modal-2 class="btn-link">Change Password</a></li>
            </ul>
        </b-card>
        <account-info-form></account-info-form>
        <b-modal
            id="modal-2"
            title="Change Password"
            ok-title="Change Password"
            @ok="trySave()"
            @cancel="reset()"
        >
            <b-form-group
                label="New password"
                label-class="font-weight-bold"
            >
                <b-form-input v-model="newPassword" type="password"></b-form-input>
            </b-form-group>
            <b-form-group
                label="Current password (or temporary pin)"
                label-class="font-weight-bold"
            >
                <b-form-input v-model="currentPassword" type="password"></b-form-input>
            </b-form-group>
        </b-modal>
    </b-container>
</template>
<script>
import EditAccountInformationForm from "./forms/EditAccountInformationForm.vue";

export default {
    components: {
        "account-info-form": EditAccountInformationForm
    },
    data() {
        return {
            currentPassword : "",
            newPassword     : ""
        };
    },
    methods: {
        reset() {
            this.currentPassword = "";
            this.newPassword     = "";
        },
        trySave() {
            this.$api.post(
                "/api/account/changePassword",
                {
                    currentPassword : this.currentPassword,
                    newPassword     : this.newPassword
                }
            ).then((response) => {
                const data = response.data;
                this.$bvToast.toast(data.message, {
                    title:   (data.success) ? "Success" : "Error",
                    variant: (data.success) ? "success" : "danger",
                    autoHideDelay: 5000,
                    appendToast: true
                });
                this.reset();
            });
        }
    }
}
</script>